(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-mar"] && !Shopify.designMode) return;
  try {
    
class KsMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.ks-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    console.log(list)
    const marqueeWidth = list.scrollWidth
    console.log(list.scrollWidth)
    const marqueeLength = list.querySelectorAll('li').length 

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #ks-marquee-${this.dataset.sectionId} ul {
          animation-name: ks-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes ks-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes ks-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('ks-marquee', KsMarquee)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-shop-videos"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor() {
    super()

    this.initLibraries()
    this.prepareVideos()
    this.initSwiper()
  }

  initLibraries() {
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute(
        'href',
        'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css'
      )
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute(
        'integrity',
        'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow='
      )
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute(
        'src',
        'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js'
      )
      script.setAttribute('id', 'swiper-script')
      script.setAttribute(
        'integrity',
        'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0='
      )
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }
  }

  initSwiper() {
    const tryInit = () => {
      if (!window.Swiper) {
        setTimeout(tryInit, 100)
        return
      }

      if (this.slider) return

      this.slider = new window.Swiper(
        this.querySelector('.swiper'),
        this.sliderOptions()
      )
    }

    tryInit()
  }

  prepareVideos() {
    this.querySelectorAll('video').forEach((video) => {
      video.muted = true
      video.defaultMuted = true
      video.loop = true
      video.autoplay = true
      video.playsInline = true

      video.setAttribute('muted', '')
      video.setAttribute('autoplay', '')
      video.setAttribute('loop', '')
      video.setAttribute('playsinline', '')

      const playVideo = () => {
        video.muted = true

        const playPromise = video.play()

        if (playPromise !== undefined) {
          playPromise.catch(() => {})
        }
      }

      if (video.readyState >= 2) {
        playVideo()
      } else {
        video.addEventListener(
          'loadeddata',
          () => {
            playVideo()
          },
          { once: true }
        )
      }

      video.addEventListener('pause', () => {
        setTimeout(() => {
          if (document.visibilityState === 'visible') {
            playVideo()
          }
        }, 100)
      })

      video.addEventListener('volumechange', () => {
        if (!video.muted) {
          video.muted = true
        }
      })
    })

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.querySelectorAll('video').forEach((video) => {
          video.muted = true

          const playPromise = video.play()

          if (playPromise !== undefined) {
            playPromise.catch(() => {})
          }
        })
      }
    })
  }

  sliderOptions() {
    const partialSlidesMobile =
      this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    return {
      rewind: true,

      speed: Number(this.dataset.sliderSpeed),

      breakpoints: {
        0: {
          slidesPerView:
            Number(this.dataset.breakpointXs) * partialSlidesMobile
        },

        576: {
          slidesPerView:
            Number(this.dataset.breakpointSm)
        },

        768: {
          slidesPerView:
            Number(this.dataset.breakpointMd)
        },

        992: {
          slidesPerView:
            Number(this.dataset.breakpointLg)
        },

        1200: {
          slidesPerView:
            Number(this.dataset.breakpointXl)
        },

        1400: {
          slidesPerView:
            Number(this.dataset.breakpointXxl)
        }
      },

      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },

      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: true,
        dynamicMainBullets: 2,

        renderFraction(currentClass, totalClass) {
          return `
            <span class="${currentClass}"></span>/
            <span class="${totalClass}"></span>
          `
        }
      },

      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },

      autoplay:
        this.dataset.sliderAutoplay !== '0'
          ? {
              delay: Number(this.dataset.sliderAutoplay) * 1000,
              disableOnInteraction: false
            }
          : undefined,

      watchSlidesProgress: true,

      mousewheel: {
        enabled: true,
        forceToAxis: true
      }
    }
  }
}

if (!customElements.get('ks-shoppable-videos')) {
  customElements.define(
    'ks-shoppable-videos',
    KsShoppableVideos
  )
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-sticky-atc"] && !Shopify.designMode) return;
  try {
    
class KsStickyOffer extends HTMLElement {
  constructor() {
    super()
    this.handleVisibility()
    this.handleChooseOffer()
  }

  handleVisibility() {
    const trigger = document.querySelector('product-info')
    if (!trigger) return

    const triggerPoint =
      trigger.getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
      if (window.scrollY > triggerPoint) {
        this.classList.add('show')
        document.body.style.paddingBottom = this.offsetHeight + 'px'
      } else {
        this.classList.remove('show')
        document.body.style.paddingBottom = 0
      }
    })
  }

  handleChooseOffer() {
    const btn = this.querySelector('.ks-choose-offer')
    if (!btn) return

    btn.addEventListener('click', () => {
      const target =
        document.querySelector('[data-bogos-gift]') ||
        document.querySelector('.bogos-gift') ||
        document.querySelector('product-info')

      if (!target) return

      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      target.classList.add('ks-highlight')

      setTimeout(() => {
        target.classList.remove('ks-highlight')
      }, 1200)
    })
  }
}
customElements.define('ks-sticky-offer', KsStickyOffer)

  } catch(e) { console.error(e); }
})();
})();
